// The chart contract between the investigation agent and this app, kept out of
// the component file so fast refresh still works there.

/** The fenced-code language the agent emits a chart under. */
export const AGENT_CHART_LANG = "inrange-chart";

export interface AgentChartSpec {
  title?: string;
  unit?: string;
  // Set by the server when it could not produce an honest chart - an uneven time
  // axis, a rejected query - after the agent's one correction round also failed.
  // It MUST be surfaced: drawing the series anyway reproduces the exact defect
  // this whole path exists to catch.
  error?: string;
  // Category labels, written by the SERVER in the site's timezone - the agent
  // supplies timestamps and never formats them (see health_investigation_charts).
  x: string[];
  series: { name: string; data: (number | null)[]; type?: "line" | "bar" }[];
}

/** Parse a chart spec, returning null for anything that is not usable. */
export const parseAgentChartSpec = (raw: string): AgentChartSpec | null => {
  try {
    const spec = JSON.parse(raw) as AgentChartSpec;
    if (!Array.isArray(spec?.x) || !Array.isArray(spec?.series)) return null;
    const series = spec.series.filter(
      (s) => s && typeof s.name === "string" && Array.isArray(s.data)
    );
    if (series.length === 0 || spec.x.length === 0) return null;
    return { ...spec, series };
  } catch {
    // A truncated or malformed spec must not take the whole answer down with
    // it - the caller falls back to showing the block as code.
    return null;
  }
};
